import { createContext } from 'react';

const BookLocationValuesContext = createContext({
  bookLocation: [],
});

export default BookLocationValuesContext;
